module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper pt-header65"
  }, [_c('header', {
    staticClass: "gheader -white gheader-fix"
  }, [_c('div', {
    staticClass: "gheader__link-back"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.goTop()
      }
    }
  }, [_vm._v("戻る")])]), (!_vm.notInput()) ? _c('button', {
    staticClass: "gheader__start-btn btn01 -w110",
    attrs: {
      "disabled": _vm.clicked
    },
    on: {
      "click": function($event) {
        _vm.messageSent()
      }
    }
  }, [_c('span', [_vm._v("送信する")])]) : _c('button', {
    staticClass: "gheader__start-btn btnXX -unavailable -w110"
  }, [_c('span', [_vm._v("送信する")])])]), _c('div', {
    staticClass: "container bg02 txtC moral-complete"
  }, [_vm._m(0), _c('div', {
    staticClass: "row moral-complete__sec03 -modifier bg02"
  }, [_vm._m(1), _c('div', {
    staticClass: "form-group mb20"
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_vm._v("※本社担当者のみメッセージを開封します。")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messageOfficerContent),
      expression: "messageOfficerContent"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "1000",
      "cols": "30",
      "rows": "7"
    },
    domProps: {
      "value": (_vm.messageOfficerContent)
    },
    on: {
      "change": function($event) {
        _vm.rmEmoji(_vm.messageOfficerContent)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messageOfficerContent = $event.target.value
      }
    }
  }), _c('p', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_vm._v("※投稿者の開示は原則致しません。")]), _c('p', [_vm._v("※内容に沿い女性担当者が対応しますのでご安心ください。")]), _c('p', [_vm._v("※内容に応じて役員/幹部へ共有する場合もあります。")])])]), _c('div', {
    staticClass: "row moral-complete__sec04 bg02"
  }, [(!_vm.notInput()) ? _c('button', {
    staticClass: "btn01",
    attrs: {
      "disabled": _vm.clicked
    },
    on: {
      "click": function($event) {
        _vm.messageSent()
      }
    }
  }, [_c('span', [_vm._v("メッセージを送信する")])]) : _c('button', {
    staticClass: "btn01 btnYY -unavailable"
  }, [_c('span', {
    staticStyle: {
      "background": "none"
    }
  }, [_vm._v("メッセージを送信する")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row moral-complete__sec02"
  }, [_c('h2', {
    staticClass: "moral-complete__sec02__title fz16 bold mb10 brown"
  }, [_vm._v("相談・SOSメッセージをどうぞ！")]), _c('p', {
    staticClass: "moral-complete__sec02__txt mb10"
  }, [_vm._v("現場では言いづらい事、伝えておきたいことなど"), _c('br'), _vm._v("なんでも自由に相談してほしいニャン！")]), _c('div', {
    staticClass: "moral-complete__sec02__img"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_cat_02.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "moral-complete__sec03__title fz16 mb20"
  }, [_c('span', {
    staticClass: "fz19"
  }, [_vm._v("相談・SOS")]), _vm._v("メッセージを送る")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-66be2564!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/message-send-officer.pug
// module id = 1410
// module chunks = 1